export default defineNuxtRouteMiddleware((to, _) => {
  if (['checkout', 'cart'].some(route => to.path.startsWith(route))) {
    return;
  }

  const { region, subregion, zipcode } = to.query;

  if (
    typeof region !== 'string' ||
    typeof subregion !== 'string' ||
    typeof zipcode !== 'string' ||
    !region ||
    !subregion ||
    !zipcode
  ) {
    return;
  }

  const regionStore = useRegionStore();
  regionStore.setDeliveryRegion({ region, subregion, zipcode });
  regionStore.markDeliveryPreferenceFromUrl();

  const newQuery = { ...to.query };
  delete newQuery.region;
  delete newQuery.subregion;
  delete newQuery.zipcode;

  return navigateTo({
    path: to.path,
    hash: to.hash,
    query: newQuery,
    replace: true,
  });
});
